import { Injectable } from "@angular/core";
import { Clinic } from "src/app/system/clinic/models/clinic";
import { CustomResult } from "../../../shared/models/custom-result";
import { PageData, PageData2 } from "../../../shared/models/page-data";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { NhiimiSetting } from "src/app/system/clinic/models/nhiimiSetting";
import { Role } from "src/app/permission/role/models/IRole";
import { ConsoleInfo } from "../../hcr-service.service";
import { Announcement, AnnouncementGroup, AnnouncementListDto, AnnouncementGroupDto, AnnouncementWithTargetDto, ClinicMemberDto, ChiMedSelecterGridItemDto, GetAllQueryDto, ChiMedSelecterUpdateItemDto, ChiMedExpireData } from "./announcement-model";

@Injectable({providedIn:'root'})
export class AnnouncementApi{
    apiService: WebApiService;
    /**
     *
     */
    constructor(private apiClient: WebApiClient) {
        this.apiService = apiClient.createHisService('system/Announcement');
    }

    async Get(id:number): Promise<Announcement>{
        var ret = await this.apiService.get('Get/'+id).toPromise<Announcement>();
        return ret;
    }

    async Create(model :Announcement,fileIds:number[],dataScope:number): Promise<CustomResult>{
        return this.apiService.post('Create',{
            Announcement:model,
            FileIds:fileIds,
            DataScope:dataScope
        }).toPromise();
    }

    async CreateSpecific(model :Announcement,fileIds:number[],dataScope:number): Promise<CustomResult>{
      return this.apiService.post('CreateSpecific',{
          Announcement:model,
          FileIds:fileIds,
          DataScope:dataScope
      }).toPromise();
    }

    async ExpireSpecific(model :Announcement,fileIds:number[],dataScope:number): Promise<CustomResult>{
      return this.apiService.post('ExpireSpecific',{
          Announcement:model,
          FileIds:fileIds,
          DataScope:dataScope
      }).toPromise();
    }

    async Update(model :Announcement): Promise<CustomResult>{
        return this.apiService.post('Update',model).toPromise();
    }

    async getAllClinic(): Promise<Clinic[]>{
        return this.apiService.get('GetAllClinic').toPromise<Clinic[]>()
    }

    async GetAll(q:GetAllQueryDto): Promise<PageData2<AnnouncementListDto>>{
        return this.apiService.get('GetAll',q).toPromise()
        
    }
    // async getGroups(): Promise<AnnouncementGroup[]>{
    //     return this.apiService.get('GetGroups').toPromise<AnnouncementGroup[]>()
    // }
    // async createGroups(model :AnnouncementGroup): Promise<CustomResult>{
    //     return this.apiService.post('CreateGroups',model).toPromise();
    // }

    // async updateGroups(model :AnnouncementGroup): Promise<CustomResult>{
    //     return this.apiService.post('UpdateGroups',model).toPromise();
    // }
    // async removeGroups(model :AnnouncementGroup): Promise<CustomResult>{
    //     return this.apiService.post('RemoveGroups',model).toPromise();
    // }

    async getSysAlert(): Promise<AnnouncementListDto[]>{
        return this.apiService.get('GetSysAlert').toPromise<AnnouncementListDto[]>()
    }

    // 新增 DTO 相關的 API 方法
    async getGroupsDto(): Promise<AnnouncementGroupDto[]> {
        return this.apiService.get('GetGroupsDto').toPromise();
    }

    async getAllClinicsDto(): Promise<ClinicMemberDto[]> {
        return this.apiService.get('GetAllClinicsDto').toPromise();
    }

    async getAnnouncementDto(id: number): Promise<AnnouncementWithTargetDto> {
        return this.apiService.get(`GetAnnouncementDto/${id}`).toPromise();
    }

    async createGroupDto(model: AnnouncementGroupDto): Promise<CustomResult> {
        return this.apiService.post('CreateGroupDto', model).toPromise();
    }

    async updateGroupDto(model: AnnouncementGroupDto): Promise<CustomResult> {
        return this.apiService.post('UpdateGroupDto', model).toPromise();
    }

    async removeGroupDto(groupId: number): Promise<CustomResult> {
        return this.apiService.delete(`RemoveGroupDto/${groupId}`).toPromise();
    }

    async ChiCheckMedChange(): Promise<boolean> {
        return this.apiService.get(`ChiCheckMedChange`).toPromise<boolean>();
    }
    async ChiMedChangeList(): Promise<ChiMedSelecterGridItemDto[]> {
        return this.apiService.get(`ChiMedChangeList`).toPromise<ChiMedSelecterGridItemDto[]>();
    }

    async SaveChiMedChangedItems(model: ChiMedSelecterUpdateItemDto[]): Promise<boolean> {
        return this.apiService.post('SaveChiMedChangedItems', model).toPromise();
    }
    async UpdateSChiRxExpire(model: ChiMedExpireData[]): Promise<boolean> {
        return this.apiService.post('UpdateSChiRxExpire', model).toPromise();
    }
    async CheckForUpdate(ClinicId:number): Promise<string> {
        return this.apiService.get(`CheckForUpdate`,{ClinicId}).toPromise();
    }
}
